import { Section } from "./section"

export function load(data: string | null): Array<Section> {
  if (data === null)
    return [];

  return JSON.parse(data).map(data => new Section(data));
}
